// 接口前缀
let baseUrl = "/checkinapi";
// if (process.env.NODE_ENV === "development") {
//   baseUrl = "https://msc.trackin.me"
// } else {
// 	// baseUrl = 'https://msc.trackin.me';
//   baseUrl = '/checkinapi';
//   // baseUrl = 'https://www.msccruises.com.cn';
// }
let ossBase = "https://oss-staging.msccruises.com.cn";
let uploadOssBase = "https://china-b2c-uat.oss-cn-shanghai.aliyuncs.com";
if (window.location.host.indexOf("www.msccruises.com.cn") != -1) {
  ossBase = "https://oss-prod.msccruises.com.cn";
  uploadOssBase = "https://china-b2c-prod.oss-cn-shanghai.aliyuncs.com";
}
// OSS 域名
export const ossBaseUrl = ossBase;
export const uploadOssUrl = uploadOssBase;
export default baseUrl;



// WEBPACK FOOTER //
// ./src/config/env.js